import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const RankingChart = ({ data, period }) => {
  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-gray-400">
        <div className="text-center">
          <div className="text-2xl mb-2">📈</div>
          <div className="text-sm">No ranking data available</div>
          <div className="text-xs text-gray-500 mt-1">for {period}</div>
        </div>
      </div>
    );
  }

  // Sort data chronologically (oldest first) and transform for chart
  const sortedData = [...data].sort((a, b) => a.timestamp - b.timestamp);
  const chartData = sortedData.map(entry => ({
    ...entry,
    displayDate: new Date(entry.date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: data.length > 7 ? undefined : '2-digit'
    })
  }));

  const formatTooltip = (value, name, props) => {
    if (name === 'global_rank') {
      return [`#${value}`, 'Global Rank'];
    }
    if (name === 'category_rank') {
      return [`#${value}`, 'Category Rank'];
    }
    return [value, name];
  };

  const formatYAxisTick = (value) => {
    return `#${value}`;
  };

  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
          <XAxis 
            dataKey="displayDate" 
            stroke="#9CA3AF"
            fontSize={12}
            tick={{ fill: '#9CA3AF' }}
          />
          <YAxis 
            stroke="#9CA3AF"
            fontSize={12}
            tick={{ fill: '#9CA3AF' }}
            tickFormatter={formatYAxisTick}
            reversed={true}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: '#1F2937',
              border: '1px solid #374151',
              borderRadius: '8px',
              color: '#F9FAFB'
            }}
            formatter={formatTooltip}
            labelStyle={{ color: '#9CA3AF' }}
          />
          
          {/* Global rank line */}
          <Line
            type="monotone"
            dataKey="global_rank"
            stroke="#8B5CF6"
            strokeWidth={2}
            dot={{ r: 4, fill: '#8B5CF6' }}
            connectNulls={false}
            name="Global Rank"
          />
          
          {/* Category rank line */}
          <Line
            type="monotone"
            dataKey="category_rank"
            stroke="#10B981"
            strokeWidth={2}
            dot={{ r: 4, fill: '#10B981' }}
            connectNulls={false}
            name="Category Rank"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RankingChart;
